export const sizes = {
  margins: {
    tiny: '2px',
    small: '3px',
    normal: '6px',
    large: '12px',
    huge: '24px',
    massive: '48px'
  },
  fonts: {
    tiny: '12px',
    small: '14px',
    normal: '16px',
    large: '20px',
    huge: '24px',
    massive: '36px'
  }
};

export type Sizes = typeof sizes;
